import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User } from '../api/models/User';
import { Result } from '../util/Result';
import { AppThunk } from './store';
import { LoadableResource } from '../util/LoadableResource';

export const userSlice = createSlice({
  name: 'currentUser',
  initialState: LoadableResource.notLoaded() as LoadableResource<User, string>,
  reducers: {
    /** Dispatch when the login operation has begun. */
    beganLogin: (state, action: PayloadAction<undefined>) => {
      return LoadableResource.loading();
    },
    /** Dispatch when the login operation was terminated due to the user backing out of the flow. */
    terminatedLogin: (state, action: PayloadAction<undefined>) => {
      return LoadableResource.notLoaded();
    },
    /** Dispatch when a login response is received. */
    receivedLoginResponse: (
      state,
      action: PayloadAction<{
        result: Result<User, 'invalid-credentials' | undefined>;
      }>
    ) => {
      if (action.payload.result.success) {
        return LoadableResource.loaded(action.payload.result.value);
      }
      switch (action.payload.result.error) {
        case 'invalid-credentials':
          return LoadableResource.error('Your username or password is invalid. Please try again.');
        case undefined:
          return LoadableResource.error('We encountered an error. Please try again.');
      }
    },
    /** Dispatch when a logout response is received. */
    receivedLogoutResponse: (state, action: PayloadAction<undefined>) => {
      return LoadableResource.notLoaded();
    },
    /** Dispatch when profile update reponse is received. */
    recievedPronounUpdateResponse: (state, action: PayloadAction<{ result: Result<User, undefined> }>) => {
      if (action.payload.result.success) {
        return LoadableResource.loaded(action.payload.result.value);
      }
      return LoadableResource.error('Preferred pronoun was not saved. Please try again.');
    },
    /** Dispatch when profile update reponse is received. */
    recievedPhotoUpdateResponse: (state, action: PayloadAction<{ result: Result<User, undefined> }>) => {
      if (action.payload.result.success) {
        return LoadableResource.loaded(action.payload.result.value);
      }
      return LoadableResource.error('Profile photo was not saved. Please try again.');
    },
  },
});

export const userActions = {
  /** Dispatch when the user taps the `LOGIN` button. */
  userPressedLogin: (): AppThunk => async dispatch => {
    // const { api, navigation, services } = Environment.current();
    // // 1. Dispatch began action.
    // dispatch(userSlice.actions.beganLogin());
    // // 2.) Authenticate with environments authentication service.
    // try {
    //   const authenticated = await services.authentication.authorize(['openid profile email']);
    //   // 3a.) If the user is authenticated, authenticate with the MNOHS API.
    //   if (authenticated.idToken) {
    //     const loginResponse = await api.login(authenticated.idToken);
    //     // 4.) On success, update state and navigate the user into the app.
    //     if (loginResponse.success) {
    //       dispatch(
    //         userSlice.actions.receivedLoginResponse({
    //           result: loginResponse,
    //         })
    //       );
    //       navigation.navigate('App');
    //     }
    //   }
    // } catch (error) {
    //   // 3b.) If the user backs out of the flow or encounter an error, stop showing loading indicator.
    //   dispatch(userSlice.actions.terminatedLogin());
    // }
  },
  /** Dispatch when the user taps the `Logout` link. */
  userPressedLogout: (): AppThunk => async dispatch => {
    // const { services } = Environment.current();
    // try {
    //   // 1.) Log the user out of the authentication service
    //   await services.authentication.logout();
    //   // 2.) Update state
    //   dispatch(userSlice.actions.receivedLogoutResponse());
    // } catch (error) {
    //   console.log(error);
    // }
  },
  /** Call when user saves their pronoun. */
  userSavedPronounUpdate: (pronounUpdateResponse: Result<User, undefined>): AppThunk => async dispatch => {
    dispatch(userSlice.actions.recievedPronounUpdateResponse({ result: pronounUpdateResponse }));
  },
  /** Call when user saves profile photo. */
  userSavedPhotoUpdate: (photoUpdateResponse: Result<User, undefined>): AppThunk => async dispatch => {
    dispatch(userSlice.actions.recievedPhotoUpdateResponse({ result: photoUpdateResponse }));
  },
};
